(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["esxdrcfvgbhnj"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('slideshow-carousel')) {
    customElements.define(
      'slideshow-carousel',
      class SlideshowCarousel extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-slideshow-track]');
          this.slides = Array.from(this.querySelectorAll('[data-slideshow-slide]'));
          this.dots = Array.from(this.querySelectorAll('[data-slideshow-goto]'));
          this.pauseButton = this.querySelector('[data-slideshow-pause]');
          this.index = 0;
          this.timer = null;

          if (!this.track || this.slides.length < 2) return;

          this.speed = parseInt(this.dataset.speed, 10) || 7000;
          this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.shouldAutoplay = this.dataset.autoplay === 'true' && !this.reducedMotion;

          this.onScroll = this.debounce(this.updateIndex.bind(this), 100);
          this.track.addEventListener('scroll', this.onScroll, { passive: true });

          const prev = this.querySelector('[data-slideshow-prev]');
          const next = this.querySelector('[data-slideshow-next]');
          if (prev) prev.addEventListener('click', () => this.goTo(this.index - 1, true));
          if (next) next.addEventListener('click', () => this.goTo(this.index + 1, true));

          this.dots.forEach((dot) => {
            dot.addEventListener('click', () => this.goTo(parseInt(dot.dataset.slideshowGoto, 10), true));
          });

          if (this.pauseButton) {
            this.pauseButton.addEventListener('click', () => {
              this.userPaused = !this.userPaused;
              this.userPaused ? this.stop(true) : this.start();
            });
          }

          this.addEventListener('mouseenter', () => this.stop());
          this.addEventListener('mouseleave', () => this.start());
          this.addEventListener('focusin', () => this.stop());
          this.addEventListener('focusout', () => this.start());
          document.addEventListener('visibilitychange', () => {
            document.hidden ? this.stop() : this.start();
          });

          this.start();
        }

        disconnectedCallback() {
          this.stop(true);
        }

        debounce(fn, wait) {
          let t;
          return (...args) => {
            clearTimeout(t);
            t = setTimeout(() => fn.apply(this, args), wait);
          };
        }

        updateIndex() {
          const i = Math.round(this.track.scrollLeft / this.track.clientWidth);
          if (i === this.index) return;
          this.index = i;
          this.dots.forEach((dot, n) => {
            n === i ? dot.setAttribute('aria-current', 'true') : dot.removeAttribute('aria-current');
          });
          this.restartBar();
        }

        goTo(i, manual) {
          const total = this.slides.length;
          const target = ((i % total) + total) % total;
          this.track.scrollTo({
            left: this.track.clientWidth * target,
            behavior: this.reducedMotion ? 'auto' : 'smooth',
          });
          if (manual) this.restart();
        }

        restart() {
          this.stop();
          this.start();
        }

        restartBar() {
          const active = this.querySelector('.slideshow__nav-item[aria-current="true"] .slideshow__nav-fill');
          if (!active) return;
          active.style.animation = 'none';
          void active.offsetWidth;
          active.style.animation = '';
        }

        start() {
          if (!this.shouldAutoplay || this.userPaused || this.timer) return;
          this.removeAttribute('data-paused');
          this.timer = setInterval(() => this.goTo(this.index + 1), this.speed);
        }

        stop(persist) {
          clearInterval(this.timer);
          this.timer = null;
          if (persist) this.setAttribute('data-paused', 'true');
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
